import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://zsznfbyoqgkuvjqfzisi.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpzem5mYnlvcWdrdXZqcWZ6aXNpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU3MDM1ODUsImV4cCI6MjA3MTI3OTU4NX0.9_lHhK7TnF_XLWMavWHVZBKWIhU_H-VnW3HuBxsjdQM'

export const supabase = createClient(supabaseUrl, supabaseKey)